import React from "react";

import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Typography
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";

import {
    selectSpendByCustomerProfile,
    selectSpendByCustomerProfileSort,
    setSpendByCustomerProfileSort,
    SpendByCustomerProfileSortField
} from "modules/customer/tools/location/spend/spendSlice";
import { useAppDispatch, useAppSelector } from "store";
import numberFormatter from "utils/numberFormatter";
import { SortDirection } from "utils/sortUtils";

const StyledTableContainer = withStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    }
}))(TableContainer);

const StyledTypography = withStyles(theme => ({
    root: {
        color: theme.palette.text.disabled
    }
}))(Typography);

const SpendByCustomerProfile: React.FC = () => {
    const dispatch = useAppDispatch();
    const spendByCustomerProfile = useAppSelector(selectSpendByCustomerProfile);
    const sort = useAppSelector(selectSpendByCustomerProfileSort);

    const handleSortClick = (field: SpendByCustomerProfileSortField) => () => {
        let direction = SortDirection.ASC;
        if (sort.field === field) {
            direction = sort.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }
        const newSort = { ...sort, field, direction };
        dispatch(setSpendByCustomerProfileSort(newSort));
    };

    return (
        <Box paddingTop={2} data-cy="spend-by-customer-profile">
            <Typography variant="h6" component="div">
                Spend by customer profile
            </Typography>
            <br />
            {/* @ts-ignore */}
            <StyledTableContainer component={Paper} elevation={0} data-cy="table">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                <TableSortLabel
                                    active={sort.field === SpendByCustomerProfileSortField.CustomerProfile}
                                    direction={sort.direction}
                                    onClick={handleSortClick(SpendByCustomerProfileSortField.CustomerProfile)}
                                    IconComponent={ExpandMoreIcon}
                                >
                                    {/* @ts-ignore */}
                                    <StyledTypography variant="h6" component="div">
                                        Customer profile
                                    </StyledTypography>
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center">
                                <TableSortLabel
                                    active={sort.field === SpendByCustomerProfileSortField.WeightedSpend}
                                    direction={sort.direction}
                                    onClick={handleSortClick(SpendByCustomerProfileSortField.WeightedSpend)}
                                    IconComponent={ExpandMoreIcon}
                                >
                                    {/* @ts-ignore */}
                                    <StyledTypography variant="h6" component="div">
                                        Weighted spend
                                    </StyledTypography>
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center">
                                <TableSortLabel
                                    active={sort.field === SpendByCustomerProfileSortField.SpendPerHead}
                                    direction={sort.direction}
                                    onClick={handleSortClick(SpendByCustomerProfileSortField.SpendPerHead)}
                                    IconComponent={ExpandMoreIcon}
                                >
                                    {/* @ts-ignore */}
                                    <StyledTypography variant="h6" component="div">
                                        Average spend per head
                                    </StyledTypography>
                                </TableSortLabel>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {spendByCustomerProfile.map((item, index) =>
                            <TableRow key={index}>
                                <TableCell align="left">
                                    <Typography variant="body1" component="div">
                                        {item.customerProfile}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography variant="body1" component="div">
                                        {numberFormatter.toGBP(item.weightedSpend, 1)}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography variant="body1" component="div">
                                        {numberFormatter.toGBP(item.spendPerHead, 1)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </StyledTableContainer>
        </Box>
    );
};

export default SpendByCustomerProfile;
